<template lang="pug">
  .component-packet-list
    .row
      .columns.large-offset-11.text-right
        PacketModal(@itemUpdated="itemUpdated" :title ="title")
    .row
      .column
        base-list(:component="component" :dataLoader="dataLoader", :showPerPageSelect="true", ref="list")

</template>

<script>
import BaseList from "./BaseList";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import PacketModal from "../../components/structure/ui/actions/reveal/PacketModal";

export default {
  name: "PacketList",
  components: {PacketModal, BaseList},
  data: function () {
    return {
      component: require('src/components/backoffice/Packet.vue'),
      title : 'Create new packet'
    }
  },
  created() {
  },
  methods: {
    dataLoader(callback) {
      KeplerBackofficeSdk.packets.list.all(1,25 ,(data)=> {
        callback(data)
      })
    },
    itemUpdated(op) {
      if(op === 'added') {
        this.$refs.list.loadData(1)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PacketList.vue?1ef2651e